/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  Chip,
  Menu,
  MenuItem,
  Link as LinkMui,
  Button,
  Dialog,
  Fade,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useParams } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { Download } from '@mui/icons-material';

import Table from "../../../../components/form/Table";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import Question from "../../../../components/form/Question";
import CostModal from "./CostModal";
import AddIcon from '@mui/icons-material/Add';
import { useCanView } from "../../../../config/hook/UserPermissions";

import { getProviderId } from "../../../../store/masters/thunk/provider/getId";
import { deleteCostProvider } from "../../../../store/masters/thunk/costProvider/delete";
import { postImportCostProvider } from "../../../../store/masters/thunk/importCostProvider/post";

const Cost = ({ setBtns }) => {
  const [__] = useTranslation("supplierCost");
  const dispatch = useDispatch();
  const { id } = useParams();
  const PageSize = 5;
  const canView = useCanView();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const [openModal, setOpenModal] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const inputFileRef = useRef(null);

  const costProvider = useSelector(state => state.masters.costProvider);
  const current = useSelector((state) => state.masters.provider.detail);
  const delet = useSelector(state => state.masters.costProvider.delete);
  const put = useSelector(state => state.masters.costProvider.put);
  const post = useSelector(state => state.masters.costProvider.post);
  const importCost = useSelector(state => state.masters.importCostProvider.post);

  const getData = ({ page, filter }) => {
    dispatch(getProviderId({ id }));
  };

  const reload = () => getData({ page: 1 })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1 })
  }, [dispatch])

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
    event.target.value = "";
  };

  useEffect(() => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("ProviderId", Number(id));
      formData.append("File", selectedFile);
      dispatch(postImportCostProvider(formData));
      setSelectedFile(null);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (get(importCost, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
    if (get(importCost, "isReject", false)) { setError(get(importCost, "error", {}), "post") }
  }, [importCost])

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
        <a href={`/PlantillaCostos.csv`} download>
          <Button
            variant="contained"
            color="warning"
            startIcon={<Download />}
          >
            Descargar Plantilla
          </Button>
        </a>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#00BFFF', color: 'white' }}
          startIcon={<ImportExportIcon />}
          onClick={() => {
            if (canView("MAESTROS/PROVEEDORES/COSTOS/IMPORTAR", "add")) {
              inputFileRef.current.click()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para importar costos al proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}
        >
          Importar
        </Button>
        <input
          type="file"
          accept=".csv"
          ref={inputFileRef}
          hidden
          onChange={handleFileUpload}
        />
        <Button className='w-[100px] min-w-[100px]' startIcon={<AddIcon/>} variant="contained" color="secondary" onClick={() => {
            if (canView("MAESTROS/PROVEEDORES/COSTOS", "add")) {
              setOpenModal(true)
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para agregar nuevos costos al proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`toolbar.btn`)}</Button>
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [])

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };

  const handleEditContact = (row) => {
    setSelected(row);  // Asigna el costProvidero seleccionado
    setOpenModal(true);  // Abre el modal directamente
  };

  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const onDelete = () => {
    dispatch(deleteCostProvider({ id: Number(get(selected, "id")), idProvider: Number(get(selected, "idProvider")) }));
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (costProvider) => <li>{`• ${costProvider}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" })}
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" })}
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [post, put, delet])

  const costProvidersAll = get(current, "data.providersCosts", []);

  const headTable = [
    {
      key: "status",
      label: __(`table.cols.isAutomatic`),
      align: "center"
    },
    {
      key: "thisName",
      label: __(`table.cols.idCost`),
      align: "center"
    },
    {
      key: "descriptionCost",
      label: __(`table.cols.cost`),
      align: "center"
    },
    {
      key: "customerId",
      label: __(`table.cols.customerId`),
      align: "center"
    },
    {
      key: "transportType",
      label: __(`table.cols.transportType`),
      align: "center"
    },
    {
      key: "division",
      label: __(`table.cols.division`),
      align: "center"
    },
    {
      key: "municipality",
      label: __(`table.cols.startDistrict`),
      align: "center"
    },
    {
      key: "municipalityEnd",
      label: __(`table.cols.endDistrict`),
      align: "center"
    },
    {
      key: "routeType",
      label: __(`table.cols.routeType`),
      align: "center"
    },
    {
      key: "price",
      label: __(`table.cols.price`),
      align: "center"
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]

  const dataTable = map(costProvidersAll, (row, i) => ({
    ...row,
    status: <Chip label={get(row, "isAutomatic") === true ? __("Automático") : __("No Automático")} color={get(row, "isAutomatic") === true ? "success" : "error"}/>,
    thisName: (<Button onClick={() => handleEditContact(row)}>{get(row, "id")}</Button>),
    price: `$ ${get(row, "price", 0)?.toFixed(2)}`,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))
  const onChangePagination = (e, page) => getData({ page })

  return (
    <div className='mt-4'>
      <Table headTable={headTable}  dataTable={dataTable} __={__} sizeFilters={125} loading={get(current, "isLoading", false)}/>
      {get(costProvider, "isSuccess", true) &&
        <Stack sx={{ mt: 2 }} alignContacts="flex-end">
          <Pagination
            count={(Math.trunc((get(costProvider, "totalRecords", 1) + PageSize) / PageSize))}
            page={get(costProvider, "pageNumber", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
          />
        </Stack>
      }
      {get(importCost, "isLoading", false) && (
        <Dialog open={get(importCost, "isLoading")} maxWidth="sm" sx={{ '& .MuiDialog-paper': { width: '250px', maxWidth: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 } }} >
          <Fade in={get(importCost, "isLoading")}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 }}>
              <CircularProgress />
              <Typography variant="caption" sx={{ mt: 2, ml: 2 }}>
                {__("Cargando...")}
              </Typography>
            </Box>
          </Fade>
        </Dialog>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={() => { setOpenModal(true); setAnchorEl(null) }}>{__(`table.menu.edit`)}</MenuItem>
        <MenuItem onClick={ () => {
            if (canView("MAESTROS/PROVEEDORES/COSTOS", "delete")) {
              handleDelete(selected)()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar costos del proveedor.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <CostModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        selected={selected}
        setSelected={setSelected}
        idClient={id}
      />
      <Question
        title={__("alert.deletecostProvider.title")}
        detail={__("alert.deletecostProvider.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </div>
  )
}

export default Cost;
